import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

interface IneligibilityReasonItemProps {
  $hasBullet: boolean
}

// A <span> stays valid phrasing content (unlike <li>), so it can safely sit inside the <p> that
// Tooltip wraps its label in. `display: list-item` still renders it as its own line with a
// native bullet marker when there's more than one reason. Tooltip's own <Text alignment="center">
// centers everything by default, so left-align explicitly here.
export const IneligibilityReasonItem = styled.span<IneligibilityReasonItemProps>`
  display: list-item;
  margin-left: ${({ $hasBullet }) => ($hasBullet ? Spacing.S16 : 0)};
  text-align: left;
  list-style-type: ${({ $hasBullet }) => ($hasBullet ? 'disc' : 'none')};
`
